<template>
  <el-dialog class="stationeryRecord-detail" title="审批详情" :visible="detailShow" width="700px" center
    :close-on-click-modal="false" @open="dialogOpen" @close="dialogClose">
    <div class="detail">
      <el-descriptions class="margin-top" title="" :column="2" border direction="horizontal"
        v-for="(item, index) in stationeryRecordDetail.goodsList" :key="index">
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            文具名称
          </template>
          <el-input disabled v-model.quantity="item.stationeryName" placeholder="请输入" prop="rank"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-menu"></i>
            借用数量
          </template>
          <el-input disabled v-model.quantity="item.quantity" placeholder="请输入" prop="rank" type="number"
            :min="1"></el-input>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions class="margin-top" title="" :column="1" border direction="horizontal">
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-s-check"></i>
            是否通过
          </template>
          {{
            stationeryRecordDetail.status == "0"
              ? "待审批"
              : stationeryRecordDetail.status == "1"
                ? "是" : stationeryRecordDetail.status == "1" ?
                  "否" : "已撤回"
          }}
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions class="margin-top" title="" :column="1" border direction="vertical"
        v-if="stationeryRecordDetail.status !== '0'">
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            审批说明
          </template>
          {{ stationeryRecordDetail.remark }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    detailShow: {
      type: Boolean,
    },
    stationeryRecordDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    dialogOpen() { },
    dialogClose() {
      this.$emit("update:detailShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationeryRecordDetail.scss";
</style>